import React from 'react';
import Chip from '@mui/material/Chip';

interface MemberLegacyRolePill {
  role: string;
}

const rolePill = (props: MemberLegacyRolePill) => {

  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  const { role } = props;
  if (role === 'CMS' || role === 'INSTITUTION') {
    color = 'warning'
    variant = 'outlined'
  } else if (role === 'SUPER_ADMIN') {
    color = 'primary'
    variant = 'outlined'
  } else if (role === 'BETA_TESTER') {
    color = 'success'
    variant = 'outlined'
  } else if (role === 'MEMBER') {
    color = 'secondary'
    variant = 'outlined'
  } else if (role === 'ADMIN') {
    color = 'error'
    variant = 'outlined'
  }
  return <Chip label={role} color={color} variant={variant}/>;
};

export default rolePill;
